import { render, staticRenderFns } from "./ScrollToTopComponent.vue?vue&type=template&id=50ceb8d7&scoped=true&"
import script from "./ScrollToTopComponent.vue?vue&type=script&lang=js&"
export * from "./ScrollToTopComponent.vue?vue&type=script&lang=js&"
import style0 from "./ScrollToTopComponent.vue?vue&type=style&index=0&id=50ceb8d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ceb8d7",
  null
  
)

export default component.exports